const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const html = (name, code, origin) => `<!DOCTYPE html><html lang="de"><head><meta charset="utf-8"><title>Danke-Karte ${esc(name)}</title>
<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,600&family=Nunito:wght@400;700;800&display=swap" rel="stylesheet">
<style>
@page { size: 105mm 148mm; margin: 0; }
* { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
html, body { margin: 0; padding: 0; background: #e7e5e4; }
.card { width: 105mm; height: 148mm; margin: 10mm auto; background: #120d0a; color: #f8eedd; position: relative; overflow: hidden; font-family: Nunito, sans-serif; padding: 11mm 9mm 9mm; display: flex; flex-direction: column; align-items: center; text-align: center; }
.card::before { content: ""; position: absolute; inset: 4mm; border: 0.5mm solid #d4a84a; border-radius: 3mm; pointer-events: none; }
.glow { position: absolute; top: -30mm; left: 50%; transform: translateX(-50%); width: 90mm; height: 70mm; background: radial-gradient(closest-side, rgba(232,190,100,.35), transparent); }
.logo { width: 15mm; height: 15mm; border-radius: 4mm; position: relative; }
.mug { width: 34mm; height: 34mm; object-fit: cover; border-radius: 50%; border: 0.6mm solid #d4a84a; margin-top: 5mm; position: relative; }
h1 { font-family: "Playfair Display", serif; font-size: 25pt; line-height: 1.05; margin: 5mm 0 0; color: #f1cf7e; }
p { font-size: 9.5pt; line-height: 1.5; margin: 3.5mm 0 0; color: #eadfcb; }
.code { margin-top: 5mm; padding: 2mm 5mm; border-radius: 10mm; background: linear-gradient(90deg,#f6dd99,#d4a84a,#f6dd99); color: #2a1a05; font-weight: 800; font-size: 9pt; letter-spacing: .4mm; }
.code b { font-size: 11pt; letter-spacing: .8mm; }
.sig { font-family: "Playfair Display", serif; font-style: italic; font-size: 15pt; color: #f1cf7e; margin-top: auto; padding-top: 3mm; }
.url { font-size: 7.5pt; letter-spacing: .6mm; text-transform: uppercase; color: #a89a85; margin-top: 1.5mm; }
@media print { html, body { background: none; } .card { margin: 0; } }
</style></head><body>
<div class="card"><div class="glow"></div>
<img class="logo" src="${origin}/icon-192.png" alt="">
<img class="mug" src="${origin}/merch/tasse-gold.jpg" alt="">
<h1>Danke, ${esc(name)}!</h1>
<p>Deine Unterstützung hält unsere Community lebendig und für alle kostenlos. Diese Tasse „Black &amp; Gold“ wurde extra für dich gefertigt – als kleines Dankeschön von Herzen.</p>
<div class="code">Unterstützer-Code&nbsp; <b>${esc(code)}</b></div>
<p>Teile ein Foto mit deiner Tasse in der App – wir freuen uns riesig! ☕</p>
<div class="sig">Saskia &amp; Stefan</div>
<div class="url">${new URL(process.env.REACT_APP_SITE_URL).host}</div>
</div>
<script>window.onload = () => setTimeout(() => window.print(), 600);</script>
</body></html>`;

export function printThanksCard(g) {
  const first = (g.address?.name || g.user?.name || "").trim().split(" ")[0] || "du";
  const w = window.open("", "_blank", "width=520,height=760");
  if (!w) return false;
  w.document.write(html(first, g.pay_code || "", window.location.origin));
  w.document.close();
  return true;
}
